import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
}));

export default useStyles;
